import MF_LOGO from '@kiss/assets/logos/icon_mf.png'

export { MF_LOGO }
